import { REFERRAL_STATUS_CLOSED } from 'src/components/Referrals/constants';

const isClosed = (referral = {}) => (
  referral.status === REFERRAL_STATUS_CLOSED
);

export default isClosed;
